import { useTranslation } from "react-i18next";
import nlflag from '../../../Assets/nl.svg';
import enflag from '../../../Assets/en.svg';
import deflag from '../../../Assets/de.svg';
import esflag from '../../../Assets/es.svg';
import frflag from '../../../Assets/fr.svg';
import info from '../../../Assets/info.svg';

type CountryCodeRendererProps = {
    code: string;
};

export default function CountryCodeRenderer({ code }: CountryCodeRendererProps) {
    const { t } = useTranslation();

    const getCountry: Record<string, [string, string]> = {
        'NL': [nlflag, t('organisation:theme:NL')],
        'EN': [enflag, t('organisation:theme:ENG')],
        'DE': [deflag, t('organisation:theme:DE')],
        'ES': [esflag, t('organisation:theme:ES')],
        'FR': [frflag, t('organisation:theme:FR')],
    };

    let flag = info;
    let name = 'Unknown Language';

    [flag, name] = getCountry[code.toLocaleUpperCase()];

    return (
        <div title={name} className="border border-[#D7E3F2] rounded-full bg-white h-8 overflow-hidden w-8">
            <img src={flag} alt={flag} className="h-full object-cover" draggable="false" />
        </div>
    );
}
